module.exports = __webpack_public_path__ + "img/cent.63d3c42e.png";